<template>
  <div class="input-photo-wrapper">
    <label class="input-photo position-relative" v-for="(item, idx) in [1,2,3,4]" :key="idx"
      :style="`background-image: url(${images[idx]}); background-position: center; background-size: cover;`">
      <div v-if="!images[idx]" class="input-photo-text">{{ label[idx] }}</div>
      
      <input name="product_images[]" type="hidden" :value="images[idx]">
      <input hidden type="file" 
             accept="image/*" 
             @change="chooseImage($event, idx)">
      <button type="button" class="btn btn-xs btn-danger position-absolute px-1 py-0" v-show="images[idx]" 
              style="bottom: 5px; right: 5px;"
              @click="deleteImage(idx)">delete</button>
    </label>


    <BModal ref="photo-modal" title="Upload" hide-footer>
      <div class="form-group d-flex align-items-center justify-content-center">
        <cropper
          ref="cropper"
          :src="currentImage.src"
          class="cropper"
          :stencil-props="stencilConfig"
          :resize-image="stencilResizeConfig"
          image-restriction="stencil"
        ></cropper>
      </div>
      <div class="form-group">
        <button class="btn btn-primary btn-block" @click="cropImage()">Simpan</button>
      </div>
    </BModal>
  </div>
</template>

<script>
import Vue from 'vue';
import { BModal } from 'bootstrap-vue';
import { Cropper } from 'vue-advanced-cropper';

// This function is used to detect the actual image type, 
function getMimeType(file, fallback = null) {
	const byteArray = (new Uint8Array(file)).subarray(0, 4);
    let header = '';
    for (let i = 0; i < byteArray.length; i++) {
       header += byteArray[i].toString(16);
    }
	switch (header) {
        case "89504e47":
            return "image/png";
        case "47494638":
            return "image/gif";
        case "ffd8ffe0":
        case "ffd8ffe1":
        case "ffd8ffe2":
        case "ffd8ffe3":
        case "ffd8ffe8":
            return "image/jpeg";
        default:
            return fallback;
    }
}

export default {
  data(){
    return {
      currentImage: {
        index: null,
        type: null,
        src: null
      },
      label: ['Foto utama', 'Foto 1 (atas/samping)', 'Foto 2 (dokumen lain jika ada)', 'Foto 3 (lainnya, sertifikat jika ada, dll)'],
      images: ['', '', '', ''],
      sampleImage: null,

      stencilConfig: {
        handlers: {},
        movable: false,
        scalable: false,
      },
      stencilResizeConfig: {
        adjustStencil: false
      }
    }
  },
  methods: {
    hideModal(){
      this.currentImage = {
        index: null,
        type: null,
        src: null
      }

      this.$refs['photo-modal'].hide();
    },
    chooseImage(e, idx) {
      this.$refs['photo-modal'].show();
      const file = e.target.files[0];
      
      if (file.type.indexOf('image/') === -1) {
        return;
      }

      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        
        reader.onload = (event) => {
          this.currentImage.src = event.target.result;
          this.currentImage.index = idx;
          this.currentImage.type = getMimeType(event.target.result, file.type);
        };

        reader.readAsDataURL(file);
      }
    },
    deleteImage(idx) {
      Vue.set(this.images, idx, '');
    },
    cropImage() {
      const { canvas } = this.$refs.cropper.getResult();
      const imageBase64 = canvas.toDataURL(this.currentImage.type, 0.8)

      const stringLength = imageBase64.length - 'data:image/png;base64,'.length;
      const sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
      const sizeInKb = sizeInBytes/1000;
      
      console.log("before:" + sizeInKb);

      Vue.set(this.images, this.currentImage.index, imageBase64);
      this.hideModal();
    },
    defaultSize({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height,
      };
    }
  },
  components: { BModal, Cropper }
}
</script>